import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useIndustryAutocomplete } from "@/hooks/api/search/useIndustryAutocomplete";
import useDebounceQuery from "@/hooks/useDebounceQuery";
import FormComboBox from "@/components/molecules/form/FormComboBox";
import { FormControlProps } from "@/components/molecules/form/FormControl";
import IndustryAllHandler from "@/components/organisms/filter/industry/IndustryAllHandler";

type FormIndustriesSelectProps = {
  name: string;
  industryAllFormName: string;
  onQueryChange?: (query: string) => void;
} & Omit<FormControlProps, "id" | "children">;

const FormIndustriesSelect = ({ name, industryAllFormName, onQueryChange, ...rest }: FormIndustriesSelectProps) => {
  const { t } = useTranslation();

  const [industryQuery, setIndustryQuery] = useState("");

  const { query, setDebounceQuery, isTyping } = useDebounceQuery();

  const { data: industries, isLoading: isLoadingIndustries } = useIndustryAutocomplete(query);

  return (
    <FormComboBox
      name={name}
      query={industryQuery}
      setQuery={(query) => {
        setIndustryQuery(query);
        setDebounceQuery(query);
        onQueryChange?.(query);
      }}
      multiple
      placeholder={t("search.filter.industry.placeholder")}
      options={industries || []}
      allowFreeText={false}
      showOptionsOnFocus
      isLoading={isLoadingIndustries || isTyping}
      renderBetween={<IndustryAllHandler formName={industryAllFormName} />}
      chipClassName={"max-w-1/2"}
      {...rest}
    />
  );
};

export default FormIndustriesSelect;
